<div class="main-content table-page table-page--compact fise-applications-page fise-relations-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ vista.titulo }}</h1>
        <p>{{ vista.descripcion }}</p>
      </div>
    </section>

    <section class="table-page__card fise-matrix__selector-card">
      <div class="fise-matrix__panel-head fise-matrix__panel-head--selector">
        <div class="fise-matrix__panel-copy">
          <span class="fise-matrix__panel-step">Filtros base</span>
          <h2>{{ vista.tituloFiltros }}</h2>
          <p>{{ vista.descripcionFiltros }}</p>
        </div>
      </div>

      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tipo de servidor</mat-label>
              <mat-select [ngModel]="serverTypeFilter" (ngModelChange)="onServerTypeChange($event)">
                <mat-option [value]="''">Todos</mat-option>
                <mat-option value="Físico">Físico</mat-option>
                <mat-option value="Virtual">Virtual</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>IP</mat-label>
              <input aria-label="IP" matInput soloip maxlength="15" [(ngModel)]="serverIpFilter" (ngModelChange)="onServerIpChange()" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Sistema operativo</mat-label>
              <input aria-label="Sistema operativo" matInput [maxlength]="vista.maxLongitudSo" soloLetraEspacioNumeroAcento [(ngModel)]="serverSoFilter"
                (ngModelChange)="onServerSoChange()" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Ubicación</mat-label>
              <input aria-label="Ubicación" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="serverLocationFilter"
                (ngModelChange)="onServerLocationChange()" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </section>

    <div class="fise-config__grid fise-config__grid--two">
      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Servidores</h2>
            <p>{{ vista.descripcionServidores }}</p>
          </div>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listServidor.length > 0; else servidoresEmptyState">
            <thead>
              <tr>
                <th>Servidor</th>
                <th>Sistema operativo</th>
                <th>Tipo</th>
                <th>Ubicación</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let servidorBean of listServidor" class="is-clickable"
                [class.is-selected]="servidorSelect.id_Servidor === servidorBean.id_Servidor"
                (click)="onSelectServidor(servidorBean)" (keydown.enter)="onSelectServidor(servidorBean)">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ servidorBean.ip }}</strong>
                    <span class="table-page__subtext">{{ servidorBean.descripcion || 'Sin descripción' }}</span>
                  </div>
                </td>
                <td>{{ servidorBean.so || 'Sin definir' }}</td>
                <td>{{ servidorBean.tipoServidor || 'Sin definir' }}</td>
                <td>{{ servidorBean.ubicacion || 'Sin definir' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #servidoresEmptyState>
            <div class="table-page__empty" *ngIf="!loadingServers; else servidoresLoadingState">
              <i class="material-icons">dns</i>
              <strong>No se encontraron servidores</strong>
              <span>Pruebe con otro conjunto de filtros para continuar.</span>
            </div>
          </ng-template>

          <ng-template #servidoresLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando servidores...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showServersPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ serverRangeEnd }} de {{ totalRegistrosServidor }} servidores</span>
            <span>Página {{ serverCurrentPage }} de {{ serverTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="serverPageSize" (ngModelChange)="onServerPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="serverTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstServerPage()"
              [disabled]="serverCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousServerPage()"
              [disabled]="serverCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getServerPaginationItems()">
              <button *ngIf="isPageNumber(item); else serverEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === serverCurrentPage" (click)="onServerPageChange(item)">{{ item }}</button>
              <ng-template #serverEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextServerPage()"
              [disabled]="serverCurrentPage === serverTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastServerPage()"
              [disabled]="serverCurrentPage === serverTotalPages">Último</button>
          </div>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Usuarios por Servidor</h2>
            <p *ngIf="servidorSelect.id_Servidor; else usuariosServidorPlaceholder">Servidor seleccionado: {{
              servidorSelect.ip }}</p>
            <ng-template #usuariosServidorPlaceholder>
              <p>Seleccione un servidor para cargar sus usuarios.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input aria-label="Buscar usuario" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="usuarioServidorFilter"
              (ngModelChange)="onUsuarioServidorFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listUsuariosF.length > 0; else usuariosServidorEmptyState">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Contraseña</th>
                <th>Privilegios</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listUsuariosF">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ usuarioBean.usuario }}</strong>
                    <span class="table-page__subtext">ID: {{ usuarioBean.id }}</span>
                  </div>
                </td>
                <td>
                  <div class="table-page__action-group">
                    <span class="table-page__subtext">••••••••••</span>
                    <button type="button" class="table-page__action-btn" #serverTooltip="matTooltip"
                      [matTooltip]="tooltipCopiarPass" ngxClipboard [cbContent]="usuarioBean.password"
                      (cbOnSuccess)="onclicCopiar()" (click)="serverTooltip.show()">
                      <i class="material-icons">content_copy</i>
                    </button>
                  </div>
                </td>
                <td>{{ usuarioBean.tipo_usuario || 'Sin definir' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosServidorEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsersByServer; else usuariosServidorLoadingState">
              <i class="material-icons">group</i>
              <strong>{{ getUsuariosServidorEmptyTitle() }}</strong>
              <span>{{ getUsuariosServidorEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #usuariosServidorLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios de servidor...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersServerPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersServerRangeEnd }} de {{ totalRegistrosUsuarioxServidor }} usuarios</span>
            <span>Página {{ usersServerCurrentPage }} de {{ usersByServerTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersServerPageSize" (ngModelChange)="onUsersServerPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="usersByServerTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersServerPage()"
              [disabled]="usersServerCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersServerPage()"
              [disabled]="usersServerCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getUsersServerPaginationItems()">
              <button *ngIf="isPageNumber(item); else usersServerEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === usersServerCurrentPage" (click)="onUsersServerPageChange(item)">{{ item
                }}</button>
              <ng-template #usersServerEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextUsersServerPage()"
              [disabled]="usersServerCurrentPage === usersByServerTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersServerPage()"
              [disabled]="usersServerCurrentPage === usersByServerTotalPages">Último</button>
          </div>
        </div>
      </section>
    </div>

    <div class="fise-config__grid fise-config__grid--two">
      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Aplicaciones</h2>
            <p *ngIf="servidorSelect.id_Servidor; else appsPlaceholder">Servidor seleccionado: {{ servidorSelect.ip }}
            </p>
            <ng-template #appsPlaceholder>
              <p>Seleccione un servidor para cargar sus aplicaciones.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar aplicación</mat-label>
            <input aria-label="Buscar aplicación" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="aplicacionFilter"
              (ngModelChange)="onAplicacionFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listAplicacion.length > 0; else aplicacionesEmptyState">
            <thead>
              <tr>
                <th>Aplicación</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let aplicacionBean of listAplicacion" class="is-clickable"
                [class.is-selected]="aplicacionSelect.id === aplicacionBean.id"
                (click)="onSelectAplicacion(aplicacionBean)" (keydown.enter)="onSelectAplicacion(aplicacionBean)">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ aplicacionBean.idTipo }}</strong>
                    <span class="table-page__subtext">Versión {{ aplicacionBean.version || 'N/D' }}</span>
                  </div>
                </td>
                <td>{{ aplicacionBean.descripcion || 'Sin descripción' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #aplicacionesEmptyState>
            <div class="table-page__empty" *ngIf="!loadingApps; else aplicacionesLoadingState">
              <i class="material-icons">apps</i>
              <strong>{{ getAplicacionesEmptyTitle() }}</strong>
              <span>{{ getAplicacionesEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #aplicacionesLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando aplicaciones...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showAppsPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ appsRangeEnd }} de {{ totalRegistrosA }} aplicaciones</span>
            <span>Página {{ appsCurrentPage }} de {{ appsTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="appsPageSize" (ngModelChange)="onAppsPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="appsTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstAppsPage()"
              [disabled]="appsCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousAppsPage()"
              [disabled]="appsCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getAppsPaginationItems()">
              <button *ngIf="isPageNumber(item); else appsEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === appsCurrentPage" (click)="onAppsPageChange(item)">{{ item }}</button>
              <ng-template #appsEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextAppsPage()"
              [disabled]="appsCurrentPage === appsTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastAppsPage()"
              [disabled]="appsCurrentPage === appsTotalPages">Último</button>
          </div>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Usuarios por Aplicación</h2>
            <p *ngIf="aplicacionSelect.id; else usuariosAppPlaceholder">Aplicación seleccionada: {{
              aplicacionSelect.idTipo }}</p>
            <ng-template #usuariosAppPlaceholder>
              <p>Seleccione una aplicación para consultar sus usuarios.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input aria-label="Buscar usuario" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="usuarioAppFilter"
              (ngModelChange)="onUsuarioAppFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaUsuariosxapp.length > 0; else usuariosAppEmptyState">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Contraseña</th>
                <th>Privilegios</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listaUsuariosxapp">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ usuarioBean.usuario }}</strong>
                    <span class="table-page__subtext">ID: {{ usuarioBean.id }}</span>
                  </div>
                </td>
                <td>
                  <div class="table-page__action-group">
                    <span class="table-page__subtext">••••••••••</span>
                    <button type="button" class="table-page__action-btn" #appTooltip="matTooltip"
                      [matTooltip]="tooltipCopiarPass" ngxClipboard [cbContent]="usuarioBean.password"
                      (cbOnSuccess)="onclicCopiar()" (click)="appTooltip.show()">
                      <i class="material-icons">content_copy</i>
                    </button>
                  </div>
                </td>
                <td>{{ usuarioBean.tipo_usuario || 'Sin definir' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosAppEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsersByApp; else usuariosAppLoadingState">
              <i class="material-icons">group</i>
              <strong>{{ getUsuariosAppEmptyTitle() }}</strong>
              <span>{{ getUsuariosAppEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #usuariosAppLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios de aplicación...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersAppPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersAppRangeEnd }} de {{ totalRegistrosUsuarioxApp }} usuarios</span>
            <span>Página {{ usersAppCurrentPage }} de {{ usersByAppTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersAppPageSize" (ngModelChange)="onUsersAppPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="usersByAppTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersAppPage()"
              [disabled]="usersAppCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersAppPage()"
              [disabled]="usersAppCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getUsersAppPaginationItems()">
              <button *ngIf="isPageNumber(item); else usersAppEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === usersAppCurrentPage" (click)="onUsersAppPageChange(item)">{{ item
                }}</button>
              <ng-template #usersAppEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextUsersAppPage()"
              [disabled]="usersAppCurrentPage === usersByAppTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersAppPage()"
              [disabled]="usersAppCurrentPage === usersByAppTotalPages">Último</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>